import qs from 'qs';
export function useQueryParams<T = any>(): T {
  return qs.parse(window.location.search, { ignoreQueryPrefix: true }) as unknown as T;
}
